import React from 'react'

function Copyright() {
  return (
    <div className=' text-[10px] w-full text-center self-center bottom-0'>&copy; Lauren Nicholson 2024</div>
  )
}

export default Copyright